export default {
  simpleWorkflow_set(state, workflows) {
    state.simpleWorkflows = workflows
  },
  simpleWorkflow_release(state) {
    state.simpleWorkflows = {}
  },
}
